import { useState } from 'react';
import { pdfjs, Document, Page } from 'react-pdf';
import { debounce } from 'lodash';
import Loader from '../ui/Loader';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';

import './PDFViewer.scss';

pdfjs.GlobalWorkerOptions.workerSrc = new URL(
	'pdfjs-dist/build/pdf.worker.min.js',
	import.meta.url
).toString();

const PDFViewer = ({ pdfUrl }) => {
	const [numPages, setNumPages] = useState();
	const [pageNumber, setPageNumber] = useState(1);

	const pdfLoadHanler = ({ numPages }) => {
		setNumPages(numPages);
	};

	const debSetPage = debounce((targetPage) => {
		setPageNumber(targetPage);
	}, 500);

	function changePage(offset) {
		setPageNumber(
			(prevPageNumber) => prevPageNumber + offset
		);
	}

	function previousPage() {
		changePage(-1);
	}

	function nextPage() {
		changePage(1);
	}

	return (
		<div className='pdf-viewer-container'>
			<div className='viewer-header'></div>
			<Document
				file={pdfUrl}
				onLoadSuccess={pdfLoadHanler}
				loading={<Loader />}
			>
				<Page
					pageNumber={pageNumber}
					width={640}
					height={480}
				/>
			</Document>
			<div className='viewer-footer'>
				<div className='page-fast-set'>
					<span>Go to page </span>
					<input
						type='number'
						min={1}
						max={numPages}
						onChange={(e) => debSetPage(+e.target.value)}
					></input>
				</div>
				<div className='page-buttons-set'>
					<button
						className='button primary-button'
						type='button'
						disabled={pageNumber <= 1}
						onClick={previousPage}
					>
						Prev
					</button>
					<button
						className='button primary-button'
						type='button'
						disabled={pageNumber >= numPages}
						onClick={nextPage}
					>
						Next
					</button>
				</div>
				<div className='page-legend'>
					<span>
						Page {pageNumber || (numPages ? 1 : '--')} of{' '}
						{numPages || '--'}
					</span>
				</div>
			</div>
		</div>
	);
};

export default PDFViewer;
